export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/DxfViewerWorker-legacy.c9630e7c.worker.js");
}
